/**
 * Created by nemio on 27.11.2015.
 */
import moment from 'moment';
import ja from 'moment/locale/pt-br';

moment.updateLocale('pt_BR', {
  calendar: {
    lastDay: 'Ontem',
    sameDay: 'Hoje',
    nextDay: 'Amanhã',
    lastWeek: 'Último', //Example: Last Monday
    nextWeek: 'Próximo', //Example: Next Friday
    sameElse: 'Mais Cedo'
  },
});

const pt_BR = {
  yes: 'Sim',
  no: 'Não',
  no_thanks: 'Não, obrigado',
  loading: 'Carregando...',
  global_error: 'Desculpa, local está indisponível devido a razão técnica. Por favor, tente mais tarde',
  email: 'Email',
  password: 'Senha',
  close: 'Fecha',
  favorites: 'Favoritos',
  search: 'Buscar',
  related: 'Related',
  tv: 'Canais de TV',
  movies: 'Filmes',
  tvseries: 'Series',
  on_now: 'EPG',
  cartoons: 'Infantil',
  purchases: 'Compra',
  premiere: 'Lançamento',
  my_services: {
    my_services: 'Meu serviços',
    my_rents: 'Conteúdo',
    my_subscriptions: 'Minha assinatura',
    subscriptions: 'Assinar',
    rents: 'Alugar'
  },
  page: {
    home: 'Home',
    epg: 'EPG',
    favorites: 'Favoritos',
    notifications: 'Notíficações',
    records: 'Minhas Gravações',
    purchases: 'Compra',
    related: 'Related',
    search: 'Buscar',
    collection: 'Coleção',
  },
  error: {
    invalid_credentials: 'Usuário ou senha errada',
    invalid_credentials_description: ' ',
    blocked_subscription: 'Caro Assinante, sua assinatura não está disponível neste momento. Por favor, renove sua assinatura. Obrigado',
    'invalid credentials': 'A senha antiga está incorreta',
    'passwords mismatch': 'As senhas devem corresponder.',
    'username field empty': 'E-mail de usuário obrigatório',
    'already exist': 'Este e-mail não está disponível. Escolha outro endereço de e-mail ou Iniciar sessão',
    'password field empty': 'Senha obrigatório',
    'password too short': 'A senha deve ter pelo menos 6 caracteres. Ao gerar, você pode usar letras, números e quaisquer caracteres especiais. ',
    'invalid password reset code': 'Código de confirmação inválido',
    'invalid ack': 'Código de confirmação inválido',
    'invalid pin': 'Pin Errado',
  },
  registration: {
    texts: {
      button: 'Criar Conta',
      title: 'Registrar agora!',
      description: 'Se você ainda não se registrou, faça o seu registro',
    }
  },
  login: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Esqueci minha senha',
    logout: 'Sair',
    log_in: 'Entrar'
  },
  forgot_password: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Esqueci minha Senha',
    forgot_password: 'Esqueci minha senha',
    send: 'Enviar',
    recovery_password: 'Recupera Senha',
    empty_field: 'Campo vazio',
    wrong_email: 'E-mail errado',
    reset_password_success_message: 'Você receberá um e-mail com um link para redefinir sua senha.',
    reset_password_error_message: 'Você receberá um e-mail com um link para redefinir sua senha.'
  },
  profile: {
    movie: {
      bundle: 'Pacote',
      min: 'min',
      fav_add: 'Adicionar Favoritos',
      fav_remove: 'Remover Favoritos',
      trailer: 'Trailer',
      youtube_trailer: 'Youtube Trailer',
      multiscreen: 'Continuar em outra tela',
      related: 'Relacionado',
      share: 'Compartilhar',
      select_screen: 'Seleção de Tela',
    },
    tvSeries: {
      bundle: 'Pacote',
      min: 'min',
      fav_add: 'Adicionar Favoritos',
      fav_remove: ' Remover favorito',
      trailer: 'Trailer',
      multiscreen: 'Continuar em outra Tela',
      related: 'Relacionado',
      share: 'Compartilhar',
      select_screen: 'Selecionar Tela',
      seasons: 'Temporadas',
      episodes: 'Episódios',
      season_short: 'S', //S01E12
      episode_short: 'E', //S01E12
    },
    channel: {
      calendar: {
        before: 'Antes',
        previously: 'Anterior',
        now: 'Agora',
        after: 'Próximo',
        hereafter: 'Mais Tarde',
        yesterday: 'Ontem',
        yesterday_at: 'Ontem às',
        today: 'Hoje',
        today_at: 'Hoje às',
        tomorrow: 'Amanhã',
        tomorrow_at: 'Amanhã em',
        last: 'Último'
      },
      epg: 'EPG',
      bundle: 'Agrupar',
      min: 'min',
      fav_add: 'Adicionar Favoritos',
      fav_remove: 'Remover Favoritos',
      record_add: 'Adicionar Gravação',
      record_remove: 'Remover Gravação',
      schedule_remove: 'Cancelar Gravação',
      multiscreen: 'Continuar em outra Tela',
      share: 'Compartilhar ',
      select_screen: 'Selecionar Tela'
    },
    subscription: {
      change: 'Mudar',
      subscription: 'Assinatura',
      included: 'Incluida',
      addons: 'Adicionar',
      added: 'Remover',
      expires: 'Expira',
      bought: 'Assinei',
      owned: 'Assinado',
      subscription_period_end: 'Próximo Pagamento em',
      subscription_period_start: 'Data de início da Assinatura ',
      subscription_states: {
        active: 'Ativa',
        trialing: 'Teste',
        unpaid: 'Aguardando Pagamento',
        '_': 'Unknown',
      },
      subscribe: 'Assinatura',
      add: 'Adicionar',
      renew: 'Remover',
      cancel_sub: 'Cancelar Assinatura',
      cancel: 'Cancelar',
      canceled: 'Cancelado',
      first_payment: 'Primeiro Pagamento',
      details: 'Detalhes',
      status: 'Status',
      are_you_sure: 'Você tem Certeza?',
      cancel_desc: 'Você quer cancelar sua assinatura para?',
      re_subscribe: 'Você pode reativar sua assinatura somente após o final do período atual.',
      yes: 'Sim',
      no: 'Não',
    },
    packages: {
      included: 'Incluido',
      expires: 'Expira',
      bought: 'Assinou',
      owned: 'Assinado'
    },
    epg_event: {
      remind_me: 'Lembrar',
      not_remind: 'Não lembrar',
      record_add: 'Adicionar Gravação',
      record_remove: 'Deletar Gravação',
      schedule_remove: 'Cancelar Gravação'
    },
    notification: {
      remind_me: 'Lembrar',
      not_remind: 'Não Lembrar'
    },
    npvr: {
      record_add: 'Adicionar Gravação',
      record_remove: 'Deletar Gravação',
      schedule_remove: 'Cancelar Gravação'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Operador',
      assembly: 'Assembleia',
      actor: 'Ator',
      director: 'Diretor',
      scenario: 'Cenário',
      composer: 'Autor',
      presenter: 'Apresentador',
      music_director: 'Diretor Musical',
      playback_singers: 'Playback Singers',
      _: 'Outros',
    },
    offers: {
      type: {
        'free': 'Grátis',
        'create-subscription': 'Assinatura',
        'purchase-asset': 'Assinar',
        'purchase-asset-rent': 'Alugar',
        'add-addon': 'Adicionar',
        'change-subscription-plan': 'Mudar',
        'renew-subscription': 'Renovar',
        '_': 'outro',
      },
      per: 'per',
      free_trial: 'Teste Grátis',
      free_trial_description: 'No fim do período de teste, a taxa de Ativação será cobrada para continuar o serviço.',
      unpaid: 'Você tem assinatura não paga. Para continuar assistindo - por favor renovar ',
      no_payment_options: 'Sem opções de pagamento'
    }
  },
  player: {
    no_signal: 'Sem sinal',
    reload: 'Recarregar',
    youtube_connection_error: 'Erro de conexão do Youtube',
  },
  more_menu_items: 'Mais',
  empty_section: 'A seção atual está vazia',
  empty_result: 'Sem resultado',
  epg: {
    no_data: 'Não há data',
    now: 'Agora',
    today: 'Hoje'
  },
  npvr: {
    filters: {
      status: 'Classificar por estado de gravação',
      date: 'Classificar por data de gravação',
      alphabet: 'Classificar por título de gravação',
      channel: 'Classificar por canal de gravação'
    },
    status: {
      pending: 'Pendente',
      scheduled: 'No cronograma',
      recording: 'Em progresso',
      finished: 'Acabou',
      failed: 'Falhou',
      cancelled: 'Cancelado pelo usuário'
    },
    usage: 'Usou',
    limit_desc: 'Isso indica quanto espaço você usou no espaço total disponível.',
    limit_desc_warning: 'Você quase atingiu o limite de programas gravados',
    limit_desc_reached: 'Você atingiu seu limite de gravações nPVR, remova algumas gravações existentes para o espaço livre.',
  },
  genres: 'Género',
  messages: {
    pin: {
      title: 'Digite seu código PIN',
      ok: 'OK',
      cancel: 'Cancelar'
    },
    notification: {
      title: 'Lembrete',
      on_channel: ' canal ligado',
      is_switch_show_right_now: 'começa em 5 minutos. Mude para assistir  agora? ',
    },
    share_request: {
      title: 'Compartilhar ',
      vod: 'video',
      live: 'canal',
      you_have_received: 'Você recebeu',
      sharing_notification: ' Compartilhando notificação . Você quer assistir?',
    },
    bookmark: {
      title: 'Continuar  assistindo?',
      continue_from: 'Continue from',
      start_over: 'Recomeçar'
    }
  },
  settings: {
    settings: 'Configurações',
    tabs: {
      login: {
        title: 'Usuário',
        email: 'Email',
        password: 'Senha',
        sign_in: 'Assinar',
        error: 'Usuário ou a senha estão errados',
        success: 'Bem-vindo, querido, cliente!',
      },
      registration: {
        title: 'Cadastro',
        email: 'Email',
        password: 'Senha',
        password2: 'Confirmar Senha',
        first_name: 'Nome',
        last_name: 'Sobre Nome',
        sign_up: 'Assinar',
        success: 'Obrigado por sua assinatura!',
        need_confirmation: 'Uma mensagem de sua assinatura foi enviada para o seu endereço de e-mail. Abra seu e-mail e clique no link para confirmar sua assinatura.',
      },
      registration_confirm: {
        success: 'Obrigado por sua assinatura. Seu Usuário e senha agora podem ser usados em outros dispositivos onde este serviço está disponível.',
      },
      language: {
        title: 'Indioma',
        select_language: 'Selecionar Indioma',
      },
      parental_control: {
        title: 'Controle dos Pais',
        description: 'Habilitar controle dos Pais',
        on: 'Ligado',
        off: 'Desligado',
      },
      change_password: {
        title: 'Mudar senha',
        save: 'Save',
        old_password: 'Senha Antiga',
        new_password: 'Digite uma nova senha',
        new_password2: 'Confirme a Senha',
        success: 'Senha atualizada com sucesso'
      },
      reset_password: {
        title: 'Redefinir senha',
        save: 'Salve',
        enter_new_password: 'Digite uma nova senha',
        ack: 'Código de confirmação',
        password: 'Nova senha',
        success: 'Senha atualizada com sucesso'
      },
    },
  },
  toast: {
    type: {
      record: 'Gravar',
      favorite: 'Favorito',
      notification: 'Notificação',
      purchase: 'Compra',
      service: 'Serviço',
      cookies: 'Cookies',
      adblock: 'Ad block',
    },
    operation: {
      record_add_success: 'A gravação de programação foi bem sucedida',
      record_add_fail: 'Gravação da programação falhou',
      record_remove_success: 'Cancelar gravação foi bem sucedida',
      record_remove_fail: 'Cancelar gravação falhou',
      favorite_add_success: 'Foi adicionado com sucesso',
      favorite_add_fail: 'Adicionar Falhou',
      favorite_remove_success: 'Retirou com sucesso',
      favorite_remove_fail: 'Retiração  Favorito Falhou',
      notification_add_success: 'Foi adicionado com sucesso',
      notification_add_fail: ' falha ao adicionar',
      notification_remove_success: 'retirado com sucesso',
      notification_remove_fail: 'falha ao Retirar',
      purchase_add_success: 'Operação foi concluída com sucesso',
      purchase_add_fail: 'Operação falhou',
      purchase_remove_success: 'Operação foi concluída com sucesso',
      purchase_remove_fail: 'Operação falhou',
      service_unstable_connection: 'Conexão instável ao servidor',
      enable_cookies: 'Por favor, ative os cookies.',
      disable_adblock: 'AdBlock pode afetar a funcionalidade do site. ' +
      'Por favor, adicione-nos à lista branca no bloqueador de anúncios.'
    }
  }
};

export default pt_BR;



// WEBPACK FOOTER //
// ./src/locales/dics/pt_BR.js